<div class="add-vm-dialog-container">
  <div class="dialog-header">
    <div class="header-titles">
      <h2 mat-dialog-title class="dialog-title">
        {{ 'boxes.provisioning.title' | translate }}
      </h2>
      <p class="dialog-subtitle">{{ 'boxes.provisioning.subtitle' | translate }}</p>
    </div>
  </div>

  <div class="step-indicator">
    <div class="step-item" [class.active]="state().status === 'idle'" [class.completed]="state().status !== 'idle'">
      <div class="step-circle">
        @if (state().status !== 'idle') {
          <mat-icon>check</mat-icon>
        } @else {
          <span class="step-number">1</span>
        }
      </div>
      <span class="step-label">{{ 'boxes.provisioning.step1Title' | translate }}</span>
    </div>
    <div class="step-connector" [class.filled]="state().status !== 'idle'"></div>
    <div
      class="step-item"
      [class.active]="state().status === 'provisioning'"
      [class.completed]="state().status === 'downloading' || state().status === 'completed'"
    >
      <div class="step-circle">
        @if (state().status === 'downloading' || state().status === 'completed') {
          <mat-icon>check</mat-icon>
        } @else {
          <span class="step-number">2</span>
        }
      </div>
      <span class="step-label">{{ 'boxes.provisioning.step2Title' | translate }}</span>
    </div>
    <div
      class="step-connector"
      [class.filled]="state().status === 'downloading' || state().status === 'completed'"
    ></div>
    <div
      class="step-item"
      [class.active]="state().status === 'downloading'"
      [class.completed]="state().status === 'completed'"
    >
      <div class="step-circle">
        @if (state().status === 'completed') {
          <mat-icon>check</mat-icon>
        } @else {
          <span class="step-number">3</span>
        }
      </div>
      <span class="step-label">{{ 'boxes.provisioning.step3Title' | translate }}</span>
    </div>
    <div class="step-connector" [class.filled]="state().status === 'completed'"></div>
    <div class="step-item" [class.active]="state().status === 'completed'">
      <div class="step-circle">
        <span class="step-number">4</span>
      </div>
      <span class="step-label">{{ 'boxes.provisioning.step4Title' | translate }}</span>
    </div>
  </div>

  <mat-dialog-content class="dialog-body">
    @if (state().status === 'idle') {
      <div class="config-step-view">
        <div class="field-container">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'boxes.provisioning.nameLabel' | translate }}</mat-label>
            <input
              matInput
              id="vmNameInput"
              name="vmName"
              [ngModel]="vmName()"
              (ngModelChange)="vmName.set($event)"
              [placeholder]="'boxes.provisioning.namePlaceholder' | translate"
              maxlength="50"
            />
            <mat-hint>{{ 'boxes.provisioning.nameHint' | translate }}</mat-hint>
          </mat-form-field>
        </div>

        <div class="hv-selection-section">
          <label class="section-label">{{ 'boxes.provisioning.selectHypervisor' | translate }}</label>
          <div class="hv-grid">
            @for (hv of hypervisorOptions; track hv.id) {
              <button
                type="button"
                class="hv-card"
                [class.selected]="selectedHypervisor() === hv.id"
                (click)="selectHypervisor(hv.id)"
              >
                <div class="hv-icon-wrapper">
                  <mat-icon class="hv-type-icon">dns</mat-icon>
                </div>
                <div class="hv-details">
                  <span class="hv-name">{{ hv.nameKey | translate }}</span>
                  <span class="hv-desc">{{ hv.descKey | translate }}</span>
                </div>
              </button>
            }
          </div>
        </div>
      </div>
    }

    @if (state().status === 'provisioning') {
      <div class="progress-step-view">
        <div class="progress-header-icon">
          <mat-spinner diameter="52" color="primary"></mat-spinner>
        </div>

        <h3 class="progress-status-title">
          {{ provisioningStepTranslationKey() | translate }}
        </h3>

        <div class="progress-bar-wrapper">
          <mat-progress-bar
            mode="determinate"
            [value]="provisioningProgressPercent()"
            color="primary"
          ></mat-progress-bar>
        </div>

        <div class="metrics-row">
          <div class="metric-item highlight">
            <span class="metric-label">{{ 'common.status' | translate }}</span>
            <span class="metric-value">{{ provisioningProgressPercent() }}%</span>
          </div>
          <div class="metric-item">
            <span class="metric-label">{{ 'boxes.provisioning.step2Title' | translate }}</span>
            <span class="metric-value">
              {{
                'boxes.provisioning.steps.' + (state().currentStep ? state().currentStep!.toLowerCase() : 'preparing')
                  | translate
              }}
            </span>
          </div>
          <div class="metric-item highlight">
            <span class="metric-label">{{ 'boxes.provisioning.remaining' | translate }}</span>
            <span class="metric-value">
              {{
                provisioningCountdownSeconds() >= 5
                  ? ('provisioning.timeRemaining' | translate: { seconds: provisioningCountdownSeconds() })
                  : ('provisioning.fewSecondsRemaining' | translate)
              }}
            </span>
          </div>
        </div>
      </div>
    }

    @if (state().status === 'downloading') {
      <div class="progress-step-view">
        <div class="progress-header-icon">
          <div class="download-icon-circle">
            <mat-icon class="pulse-icon">cloud_download</mat-icon>
          </div>
        </div>

        <h3 class="progress-status-title">
          {{ 'boxes.provisioning.downloadingMessage' | translate }}
        </h3>

        <div class="progress-bar-wrapper">
          <mat-progress-bar
            [mode]="state().totalBytesKnown ? 'determinate' : 'indeterminate'"
            [value]="state().progress"
            color="primary"
          ></mat-progress-bar>
        </div>

        <div class="metrics-row">
          <div class="metric-item highlight">
            <span class="metric-label">{{ 'common.status' | translate }}</span>
            <span class="metric-value">
              {{
                state().totalBytesKnown ? state().progress + '%' : ('boxes.provisioning.status.downloading' | translate)
              }}
            </span>
          </div>
          <div class="metric-item">
            <span class="metric-label">{{ 'boxes.provisioning.downloaded' | translate }}</span>
            <span class="metric-value">
              {{
                state().totalBytesKnown
                  ? formatBytes(state().downloadedBytes) + ' / ' + formatBytes(state().totalBytes)
                  : formatBytes(state().downloadedBytes)
              }}
            </span>
          </div>
          <div class="metric-item">
            <span class="metric-label">{{ 'boxes.provisioning.remaining' | translate }}</span>
            <span class="metric-value">
              {{
                state().timeRemainingSeconds !== null && state().timeRemainingSeconds !== undefined
                  ? formatEta(state().timeRemainingSeconds)
                  : ('boxes.provisioning.remainingUnknown' | translate)
              }}
            </span>
          </div>
        </div>
      </div>
    }

    @if (state().status === 'completed') {
      <div class="completion-step-view">
        <div class="success-banner">
          <mat-icon class="success-icon">check_circle</mat-icon>
          <div class="success-text">
            <h3 class="success-title">{{ 'boxes.provisioning.status.completed' | translate }}</h3>
            <p class="file-name">{{ state().fileName }}</p>
          </div>
        </div>

        @if (state().checksum) {
          <div class="checksum-card">
            <div class="checksum-header">
              <div class="checksum-title-row">
                <mat-icon class="security-icon">verified_user</mat-icon>
                <span class="checksum-title">{{ 'boxes.provisioning.checksumTitle' | translate }}</span>
              </div>
              @if (copiedChecksum()) {
                <span class="copied-badge">{{ 'boxes.provisioning.copied' | translate }}</span>
              }
            </div>
            <p class="checksum-subtitle">{{ 'boxes.provisioning.checksumSubtitle' | translate }}</p>

            <div class="checksum-display-box" (click)="copyChecksum()">
              <code class="checksum-hash">{{ state().checksum }}</code>
              <button
                mat-icon-button
                type="button"
                class="copy-btn"
                (click)="$event.stopPropagation(); copyChecksum()"
                [matTooltip]="'boxes.provisioning.copyChecksum' | translate"
              >
                <mat-icon>{{ copiedChecksum() ? 'check' : 'content_copy' }}</mat-icon>
              </button>
            </div>
          </div>

          <div class="verify-guide-wrapper">
            <div class="guide-toggle-header" (click)="toggleGuide()">
              <div class="guide-title">
                <mat-icon class="guide-icon">terminal</mat-icon>
                <span>{{ 'boxes.provisioning.verifyGuideTitle' | translate }}</span>
              </div>
              <mat-icon class="toggle-arrow">{{ guideOpen() ? 'expand_less' : 'expand_more' }}</mat-icon>
            </div>

            @if (guideOpen()) {
              <div class="guide-content">
                <p class="guide-hint">{{ 'boxes.provisioning.verifyGuideHint' | translate }}</p>

                <div class="command-block">
                  <div class="command-header">
                    <span>{{ 'boxes.provisioning.verifyGuideWindows' | translate }}</span>
                    @if (copiedCmdWindows()) {
                      <span class="cmd-copied">{{ 'boxes.provisioning.copied' | translate }}</span>
                    }
                  </div>
                  <div class="command-box">
                    <code>{{ getWindowsVerifyCommand() }}</code>
                    <button mat-icon-button type="button" (click)="copyCommand(getWindowsVerifyCommand(), 'windows')">
                      <mat-icon>{{ copiedCmdWindows() ? 'check' : 'content_copy' }}</mat-icon>
                    </button>
                  </div>
                </div>

                <div class="command-block">
                  <div class="command-header">
                    <span>{{ 'boxes.provisioning.verifyGuideLinux' | translate }}</span>
                    @if (copiedCmdLinux()) {
                      <span class="cmd-copied">{{ 'boxes.provisioning.copied' | translate }}</span>
                    }
                  </div>
                  <div class="command-box">
                    <code>{{ getLinuxVerifyCommand() }}</code>
                    <button mat-icon-button type="button" (click)="copyCommand(getLinuxVerifyCommand(), 'linux')">
                      <mat-icon>{{ copiedCmdLinux() ? 'check' : 'content_copy' }}</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="checksum-unavailable-card">
            <div class="checksum-unavailable-header">
              <mat-icon class="info-icon">info_outline</mat-icon>
              <span class="unavailable-title">{{ 'boxes.provisioning.checksumUnavailableTitle' | translate }}</span>
            </div>
            <p class="unavailable-text">{{ 'boxes.provisioning.checksumUnavailableSubtitle' | translate }}</p>
          </div>
        }
      </div>
    }

    @if (state().status === 'error') {
      <div class="error-step-view">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <h3>{{ 'provisioning.status.FAILED' | translate }}</h3>
        <p class="error-msg">{{ state().error || ('provisioning.steps.FAILED' | translate) }}</p>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    @if (state().status === 'idle') {
      <button mat-button type="button" (click)="handleClose()">
        {{ 'boxes.provisioning.cancel' | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="!selectedHypervisor()"
        (click)="startDownload()"
      >
        <mat-icon>download</mat-icon>
        {{ 'boxes.provisioning.startDownload' | translate }}
      </button>
    }

    @if (state().status === 'provisioning' || state().status === 'downloading') {
      <button mat-button type="button" (click)="cancelDownload()">
        {{ 'boxes.provisioning.cancel' | translate }}
      </button>
    }

    @if (state().status === 'completed') {
      <button mat-button type="button" (click)="resetForm()">
        <mat-icon>add</mat-icon>
        {{ 'boxes.provisioning.anotherVm' | translate }}
      </button>
      <button mat-flat-button color="primary" type="button" (click)="handleClose()">
        {{ 'boxes.provisioning.close' | translate }}
      </button>
    }

    @if (state().status === 'error') {
      <button mat-button type="button" (click)="cancelDownload()">
        {{ 'boxes.provisioning.cancel' | translate }}
      </button>
      <button mat-flat-button color="primary" type="button" (click)="handleClose()">
        {{ 'boxes.provisioning.close' | translate }}
      </button>
    }
  </mat-dialog-actions>
</div>
